<template>
  <div class="relative overflow-hidden pt-12 pb-32 lg:pt-0">
    <div class="relative">
      <div
        class="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8 lg:align-middle"
      >
        <div
          class="mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:py-24 lg:px-0 2xl:py-48"
        >
          <div>
            <div>
              <span class="justify-left flex items-center">
                <img
                  class="w-64 rounded-lg bg-black p-4"
                  :src="data.logo"
                  :alt="data.img.alt"
                />
              </span>
            </div>
            <div class="mt-16">
              <h2 class="text-3xl font-extrabold tracking-tight">
                {{ data.title }}
              </h2>
              <p
                class="mt-4 text-justify text-lg text-gray-500 dark:text-gray-400"
              >
                {{ data.text }}
              </p>
              <div class="mt-6">
                <a
                  @click="scrollToPlans"
                  class="bg-ontick-green-600 text-ontick-carbon-900 hover:bg-ontick-green-700 inline-flex items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium"
                >
                  Começar!
                </a>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-6">
            <blockquote>
              <div>
                <p class="text-base text-gray-500 dark:text-gray-400">
                  "{{ data.testimonial.text }}"
                </p>
              </div>
              <footer class="mt-3">
                <div class="flex items-center space-x-3">
                  <div
                    class="text-base font-medium text-gray-700 dark:text-gray-500"
                  >
                    {{ data.testimonial.author.name }}
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
        <div class="mt-12 sm:mt-16 lg:-mt-20">
          <div class="lg:h-full">
            <img
              class="h-screen max-w-none lg:left-0 lg:pb-4"
              :src="data.img.url"
              :alt="data.img.alt"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    partnerInfo: {
      type: Object,
    },
  },

  methods: {
    scrollToPlans() {
      const plans = document.getElementById("plans");
      plans.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style></style>
